<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Código</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="codigo"
                            :state="$v.codigo.$error ? false : null"
                            @input.native="$v.codigo.$touch()"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            O código do processo é obrigatório
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label>Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="3"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" v-if="this.tipoOperacao == 'i'">
                <b-form-group>
                    <label>Documento</label>
                    <b-form-file
                        v-model="documento"
                        placeholder="Selecione o documento..."
                        ref="documentoInput"
                        browse-text="Selecionar"
                    ></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
            >
                Salvar
            </b-button
            >
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ProcessosJudiciaisServicos from './ProcessosJudiciaisServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        processo: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            codigo: null,
            descricao: null,
            documento: null,
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = []
            this.codigo = null
            this.descricao = null
            this.documento = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.tipoOperacao == 'a') {
                this.obterProcesso()
            }
        },

        obterProcesso() {
            this.$store.dispatch('addRequest')
            ProcessosJudiciaisServicos.obterProcesso(
                this.contrato.idContrato,
                this.processo.idProcessoJudicialContrato
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.descricao = response.data.descricao
                        this.codigo = response.data.codigo
                    } else {
                        this.$toast.error(
                            'Erro ao obter a manutenção',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção do Processo Judicial?'
            } else {
                msg = 'Confirma a atualização do Processo Judicial?'
            }

            this.$swal({
                title: 'Processo Judicial do Contrato',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let processoDto = {
                codigo: this.codigo,
                descricao: this.descricao,
                documento: this.documento,
                idContrato: this.contrato.idContrato
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = ProcessosJudiciaisServicos.inserir(processoDto)
            } else {
                processoDto = { ...processoDto, idProcessoJudicialContrato: this.processo.idProcessoJudicialContrato }
                promisse = ProcessosJudiciaisServicos.atualizar(this.contrato.idContrato, processoDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterProcessosAtualizados')
            this.fecharModal()
        },
    },

    created() {
        this.preencherForm()
    },

    computed: {
        operacao() {
            switch (this.tipoOperacao) {
                case 'i':
                    return 'INSERIR'
                case 'a':
                    return 'ATUALIZAR'
                default:
                    break
            }
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        codigo: {
            required
        },
        descricao: {
            required
        },
        documento: {

        }
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>